import { AgentPayoutSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * `agents/{agentId}/payouts/{payoutId}` — payout batches swept from the
 * agent's `earningsLedger` by the super-admin `runPayoutBatch` /
 * `executePayoutBatch` Cloud Function (Sprint 97/98). Each doc carries the
 * batch's `grossAmount` (sen), `status` (pending/processing/paid/failed),
 * `method`, `destination` snapshot, period bounds, and — once settled by
 * `markPayoutPaid` — `paidAt` + `txRef`.
 *
 * Read-only from the client: tenant isolation is enforced upstream by
 * firestore.rules (`agents/{agentId}/{document=**}` → `isThisAgent`). Extra
 * server-written fields (`initiatedBy`, `platformBrandId`, `recipientKind`)
 * are not in `AgentPayoutSchema` and are stripped by the Zod parse on read.
 */
export function agentPayoutsRepoFor(agentId: string) {
  return createRepo({
    path: `agents/${agentId}/payouts`,
    schema: AgentPayoutSchema,
    name: `agents/${agentId}/payouts`,
  });
}
